export const EXPORT_PREFIX = 'IP_Rights';
